// Shared links and contact details used across the header, footer and pages.

export const CONTACT = {
  phone: '+91 7988079881',
  phoneHref: 'tel:+917988079881',
  email: 'contact@poultryfy.com',
  address: 'Village Khera Khemawati, Tehsil Safidon, Distt Jind, HR 126112',
  company: 'Protein Revolution Foods Private Limited',
}

export const APP_LINKS = {
  userWebLogin: 'https://poultryfy.com/poultryfy/user/web/#/login',
  userPlayStore: 'https://play.google.com/store/apps/details?id=com.poultryfy_user_app&hl=en_IN',
  userAppStore: 'https://apps.apple.com/in/app/poultryfy/id6745818210',
  // The doctor app is not linked from the site; kept here for reference.
  doctorPlayStore:'https://play.google.com/store/apps/details?id=com.poultryfy_doctor&hl=en_IN',
  doctorAppStore: 'https://apps.apple.com/in/app/poultryfy-team/id6745941783',
}

// Header nav sections, reached with JS scrolling (see useSectionNav).
// Home and Contact are deliberately absent: the logo goes home, and the
// "Contact Us" button covers contact.
export const HOME_SECTIONS = [
  { id: 'features', label: 'Features' },
  { id: 'journey', label: 'How it Works' },
  { id: 'testimonials', label: 'Our Farmers' },
  { id: 'faq', label: 'FAQ' },
]

// Shared by every policy page (Privacy, Terms, Refund, Shipping, Disclaimer).
export const POLICY_EFFECTIVE_DATE = '8 October 2026'
export const REGISTERED_OFFICE = 'Khasra No. 54/2 3, Khera Khemawati, Safidon, Jind, Haryana, India - 126112'

// These routes are registered in the Play Console / App Store Connect.
// Do not rename them — see App.js.
export const LEGAL_PAGES = [
  { to: '/privacy-policy', label: 'Privacy Policy' },
  { to: '/terms-conditions', label: 'Terms & Conditions' },
  { to: '/refund', label: 'Refund Policy' },
  { to: '/shipping', label: 'Shipping Policy' },
  { to: '/disclaimer', label: 'Disclaimer' },
  { to: '/contactus', label: 'Contact Us' },
]
